/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Video_File_LabelInputs */

const en_embed_captions_video_file_label = /** @type {(inputs: Embed_Captions_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video File`)
};

const fr_embed_captions_video_file_label = /** @type {(inputs: Embed_Captions_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier video`)
};

const de_embed_captions_video_file_label = /** @type {(inputs: Embed_Captions_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videodatei`)
};

const it_embed_captions_video_file_label = /** @type {(inputs: Embed_Captions_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File video`)
};

const ru_embed_captions_video_file_label = /** @type {(inputs: Embed_Captions_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеофайл`)
};

const es_embed_captions_video_file_label = /** @type {(inputs: Embed_Captions_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo de vídeo`)
};

const zh_cn2_embed_captions_video_file_label = /** @type {(inputs: Embed_Captions_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频文件`)
};

const ja_embed_captions_video_file_label = /** @type {(inputs: Embed_Captions_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオファイル`)
};

const hi_embed_captions_video_file_label = /** @type {(inputs: Embed_Captions_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो फाइल`)
};

const pt_pt2_embed_captions_video_file_label = /** @type {(inputs: Embed_Captions_Video_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de vídeo`)
};

/**
* | output |
* | --- |
* | "Video File" |
*
* @param {Embed_Captions_Video_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_video_file_label = /** @type {((inputs?: Embed_Captions_Video_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Video_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_video_file_label(inputs)
	if (locale === "de") return de_embed_captions_video_file_label(inputs)
	if (locale === "it") return it_embed_captions_video_file_label(inputs)
	if (locale === "ru") return ru_embed_captions_video_file_label(inputs)
	if (locale === "es") return es_embed_captions_video_file_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_video_file_label(inputs)
	if (locale === "ja") return ja_embed_captions_video_file_label(inputs)
	if (locale === "hi") return hi_embed_captions_video_file_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_video_file_label(inputs)
	return en_embed_captions_video_file_label(inputs)
});